import type { ReactNode } from 'react'
import React, { useContext } from 'react'
import { Arrow, Portal, Content as TooltipContent } from '@radix-ui/react-tooltip'

import { Typography } from '../../../index'

import styles from './styles.module.css'
import { cn } from '@s4l/utility-css'
import { TooltipContext } from '../context'

export interface IContentProps {
  children?: ReactNode
  animation?: 'fade' | 'slide' | 'none'
  side?: 'left' | 'right' | 'top' | 'bottom'
}

function Content(props: IContentProps) {
  const { animation = 'fade', children, side = 'top' } = props

  const { enabled } = useContext(TooltipContext)
  if (!enabled) return null

  return (
    <Portal>
      <TooltipContent
        side={side}
        className={cn(styles.content, {
          [styles.fadeInOut]: animation === 'fade',
          [styles.slideInOut]: animation === 'slide',
        })}
      >
        <Typography variant="caption" size="l" color="var(--color-base-white)">
          {children}
        </Typography>
        <Arrow className={styles.arrow} />
      </TooltipContent>
    </Portal>
  )
}

Content.displayName = 'Tooltip.Content'

export { Content }
